var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationSendmoney = function SvgSimpleIllustrationSendmoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B268",
    d: "M36.72 3.61 5.26 13.104l6.519 5.309 1.368 11.827 4.987-5.23 7.644 6.599L36.72 3.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#085239",
    d: "m9.044 16.24-3.621-2.493s.16 3.997-.16 4.265l3.781-1.768v-.003ZM11.778 18.413l1.369 11.827L36.155 4.414l-1.206.321-23.17 13.678ZM25.336 23.845s-1.047-.845-2.052-.283c-1.005.563 0 2.374 0 2.374s1.047.683 1.892.24c.845-.442.845-1.85.16-2.334v.003ZM12.677 13.386s-1.047-.845-2.052-.282c-1.004.562 0 2.373 0 2.373s1.047.683 1.892.24c.846-.441.846-1.85.16-2.333v.002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    d: "M30.23 11.332s-3.325-1.447-6.596 2.147c-3.272 3.594-4.506 6.437-3.325 9.224l9.921-11.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#085239",
    d: "M33.018 5.863s-.537-.75-1.447-.268c-.912.481-.428 1.234-.428 1.234l1.878-.966h-.003ZM34.305 6.773l-1.447 1.662s1.181.644 1.556-.268c.375-.913-.106-1.394-.106-1.394h-.003Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002E22",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "m16.242 27.142-1.125-10.338"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#008C59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M14.997 16.644s1.114-2.469-.283-4.29l15.984-5.419M20.547 22.395s2.213-1.648 5.029-.764L32.615 8.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "m4.994 13.238 32.048-9.709-11.427 28.158-7.38-6.658-5.091 5.407-1.285-11.86-6.865-5.338ZM18.235 25.029l18.807-21.5M11.86 18.575 37.043 3.53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M4.994 13.238c1.072 2.762-.053 5.04-.053 5.04l4.09-1.906M20.354 22.574c-1.506-1.352-.49-4.942 2.27-8.015 2.62-2.92 5.869-4.324 7.48-3.305M25.512 26.068c.61-.61.556-1.653-.12-2.33-.677-.676-1.72-.73-2.33-.12-.61.61-.556 1.653.12 2.33.677.676 1.72.73 2.33.12ZM34.314 6.899c.336.47.322 1.091-.06 1.475-.36.36-.94.392-1.398.109M13.108 15.025c.36-.784-.052-1.743-.92-2.143-.87-.4-1.867-.089-2.227.695-.36.783.052 1.743.921 2.143.87.4 1.866.088 2.226-.695ZM31.115 6.899a1.016 1.016 0 0 1-.003-.851c.25-.543.94-.758 1.542-.481.137.064.26.148.364.246"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#008C59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M12.224 32.247s-.171.395-.39 1.05M11.235 35.516c-.573 2.801-.66 6.666 2.488 8.53 7.974 4.293 19.258-10.504 28.656.342M43.107 45.283c.218.288.437.59.655.91"
  })));
};
export default SvgSimpleIllustrationSendmoney;